// Depends
import { subGroup, route, professionalMeta } from '@/helpers/routes'
import Index from './index/index'
import Create from './create/create'
import Edit from './edit/edit'

const routes = [
  route('index', '/index', Index, professionalMeta('Lista de convênios')),
  route('create', '/create', Create, professionalMeta('Adicionar convênio')),
  route('edit', '/:id/edit', Edit, professionalMeta('Editar convênio'))
]

export default subGroup('/covenants', routes)



// WEBPACK FOOTER //
// ./src/app/professional/company/covenants/routes.js